// extracted by mini-css-extract-plugin
export var box = "_4c-0";
export var check = "_4c-1";
export var checkboxButton = "_4c-6";
export var checkboxGroup = "_4c-5";
export var disabled = "_4c-7";
export var ghost = "_4c-9";
export var input = "_4c-2";
export var label = "_4c-4";
export var normal = "_4c-8";
export var uncheck = "_4c-3";